/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _toConsumableArray } from '../../_chunks/dep-fd3498b6.js';
import React from 'react';
import { i as isFunction_1 } from '../../_chunks/dep-f10515e8.js';
import { CloseIcon, TimeFilledIcon, CheckCircleFilledIcon, ErrorCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-react';
import classNames from 'classnames';
import { Loading } from '../../loading/index.js';
import { Link } from '../../link/index.js';
import { abridgeName } from '../../_common/js/upload/utils.js';
import useGlobalIcon from '../../hooks/useGlobalIcon.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../loading/Loading.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_util/easing.js';
import '../../hooks/useConfig.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../hooks/useDomRefCallback.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-92728dc5.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../link/Link.js';
import '../../_util/parseTNode.js';
import '../../link/style/css.js';
import '../../_common/js/log/log.js';

function NormalFile(props) {
  var _displayFiles$, _displayFiles$0$respo;
  var theme = props.theme,
    disabled = props.disabled,
    classPrefix = props.classPrefix,
    locale = props.locale;
  var _useGlobalIcon = useGlobalIcon({
      CloseIcon: CloseIcon,
      TimeFilledIcon: TimeFilledIcon,
      CheckCircleFilledIcon: CheckCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon,
      CloseCircleFilledIcon: CloseCircleFilledIcon
    }),
    CloseIcon$1 = _useGlobalIcon.CloseIcon,
    TimeFilledIcon$1 = _useGlobalIcon.TimeFilledIcon,
    CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon,
    ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon,
    CloseCircleFilledIcon$1 = _useGlobalIcon.CloseCircleFilledIcon;
  var uploadPrefix = "".concat(classPrefix, "-upload");
  var renderProgress = function renderProgress(percent) {
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__single-progress")
    }, /* @__PURE__ */React.createElement(Loading, null), /* @__PURE__ */React.createElement("span", {
      className: "".concat(uploadPrefix, "__single-percent")
    }, percent || 0, "%"));
  };
  var renderFilePreviewAsText = function renderFilePreviewAsText(files) {
    var _files$;
    if (theme !== "file") return null;
    if (!props.multiple && ((_files$ = files[0]) === null || _files$ === void 0 ? void 0 : _files$.status) === "fail" && props.autoUpload) {
      return null;
    }
    return files.map(function (file, index) {
      var fileName = props.abridgeName && file.name ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(props.abridgeName))) : file.name;
      return /* @__PURE__ */React.createElement("div", {
        className: "".concat(uploadPrefix, "__single-display-text ").concat(uploadPrefix, "__display-text--margin"),
        key: file.name + index + file.percent + file.status
      }, file.url ? /* @__PURE__ */React.createElement(Link, {
        href: file.url,
        target: "_blank",
        hover: "color",
        size: "small",
        className: "".concat(uploadPrefix, "__single-name")
      }, fileName) : /* @__PURE__ */React.createElement("span", {
        className: "".concat(uploadPrefix, "__single-name")
      }, fileName), file.status === "fail" && /* @__PURE__ */React.createElement("div", {
        className: "".concat(uploadPrefix, "__flow-status ").concat(uploadPrefix, "__file-fail")
      }, /* @__PURE__ */React.createElement(ErrorCircleFilledIcon$1, null)), file.status === "waiting" && /* @__PURE__ */React.createElement("div", {
        className: "".concat(uploadPrefix, "__flow-status ").concat(uploadPrefix, "__file-waiting")
      }, /* @__PURE__ */React.createElement(TimeFilledIcon$1, null)), file.status === "progress" && renderProgress(file.percent), !disabled && file.status !== "progress" && /* @__PURE__ */React.createElement(CloseIcon$1, {
        className: "".concat(uploadPrefix, "__icon-delete"),
        onClick: function onClick(e) {
          return props.onRemove({
            e: e,
            file: file,
            index: index
          });
        }
      }));
    });
  };
  var renderFilePreviewAsInput = function renderFilePreviewAsInput() {
    var _props$abridgeName;
    var file = props.displayFiles[0];
    var inputTextClass = ["".concat(classPrefix, "-input__inner"), _defineProperty({}, "".concat(uploadPrefix, "__placeholder"), !props.displayFiles[0])];
    var disabledClass = disabled ? "".concat(classPrefix, "-is-disabled") : "";
    var fileName = (_props$abridgeName = props.abridgeName) !== null && _props$abridgeName !== void 0 && _props$abridgeName.length && file !== null && file !== void 0 && file.name ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(props.abridgeName))) : file === null || file === void 0 ? void 0 : file.name;
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__single-input-preview ").concat(classPrefix, "-input ").concat(disabledClass)
    }, /* @__PURE__ */React.createElement("div", {
      className: classNames(inputTextClass)
    }, /* @__PURE__ */React.createElement("span", {
      className: classNames("".concat(uploadPrefix, "__single-input-text"), _defineProperty({}, props.placeholderClass, props.placeholder))
    }, file !== null && file !== void 0 && file.name ? fileName : props.placeholder), (file === null || file === void 0 ? void 0 : file.status) === "progress" && renderProgress(file.percent), (file === null || file === void 0 ? void 0 : file.status) === "waiting" && /* @__PURE__ */React.createElement(TimeFilledIcon$1, {
      className: "".concat(uploadPrefix, "__status-icon ").concat(uploadPrefix, "__file-waiting")
    }), (file === null || file === void 0 ? void 0 : file.name) && file.status === "success" && /* @__PURE__ */React.createElement(CheckCircleFilledIcon$1, {
      className: "".concat(uploadPrefix, "__status-icon")
    }), (file === null || file === void 0 ? void 0 : file.name) && file.status === "fail" && /* @__PURE__ */React.createElement(ErrorCircleFilledIcon$1, {
      className: "".concat(uploadPrefix, "__status-icon ").concat(uploadPrefix, "__file-fail")
    }), !disabled && /* @__PURE__ */React.createElement(CloseCircleFilledIcon$1, {
      className: "".concat(uploadPrefix, "__single-input-clear"),
      onClick: function onClick(e) {
        return props.onRemove({
          e: e,
          file: file,
          index: 0
        });
      }
    })));
  };
  var displayFiles = props.displayFiles;
  var fileListDisplay = isFunction_1(props.fileListDisplay) ? props.fileListDisplay({
    files: displayFiles
  }) : props.fileListDisplay;
  var classes = ["".concat(uploadPrefix, "__single"), "".concat(uploadPrefix, "__single-").concat(theme)];
  return /* @__PURE__ */React.createElement("div", {
    className: classNames(classes)
  }, theme === "file-input" && renderFilePreviewAsInput(), props.children, theme === "file" && props.placeholder && !displayFiles[0] && /* @__PURE__ */React.createElement("small", {
    className: classNames([props.tipsClasses, props.placeholderClass])
  }, props.placeholder), fileListDisplay || renderFilePreviewAsText(displayFiles), props.sizeOverLimitMessage && /* @__PURE__ */React.createElement("small", {
    className: classNames(props.errorClasses)
  }, props.sizeOverLimitMessage), !props.multiple && ((_displayFiles$ = displayFiles[0]) === null || _displayFiles$ === void 0 ? void 0 : _displayFiles$.status) === "fail" && theme === "file" ? /* @__PURE__ */React.createElement("small", {
    className: classNames(props.errorClasses)
  }, ((_displayFiles$0$respo = displayFiles[0].response) === null || _displayFiles$0$respo === void 0 ? void 0 : _displayFiles$0$respo.error) || locale.progress.failText) : null);
}
NormalFile.displayName = "NormalFile";

export { NormalFile as default };
//# sourceMappingURL=NormalFile.js.map
